import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Plus, ArrowLeft } from "lucide-react";
import { PageHeader, GlassCard, GradButton, EmptyState, fmtMoney } from "@/components/erp";
import { MutabakatYukle } from "@/components/MutabakatYukle";
import { MutabakatSonuc } from "@/components/MutabakatSonuc";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/perms";
import api, { errMsg } from "@/lib/api";

const Gecmis = ({ list, onAc }) => (
  <GlassCard className="overflow-x-auto" data-testid="mtb-gecmis">
    {list.length === 0 ? <EmptyState text="Henüz mutabakat yapılmadı. Banka ekstrenizi yükleyerek başlayın." testid="mtb-gecmis-bos" /> : (
      <table className="w-full text-sm min-w-[640px]">
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground"><th className="p-3">No</th><th className="p-3">Hesap · dönem</th><th className="p-3">Eşleşen</th><th className="p-3">Fazla</th><th className="p-3">Eksik</th><th className="p-3">Yapan</th></tr></thead>
        <tbody>{list.map((m) => (
          <tr key={m.id} className="border-t border-white/5 cursor-pointer hover:bg-white/[0.03]" onClick={() => onAc(m.id)} data-testid={`mtb-satir-${m.no}`}>
            <td className="p-3 font-mono text-xs whitespace-nowrap">{m.no}</td><td className="p-3">{m.hesap_ad}<div className="text-xs text-muted-foreground">{m.donem_bas} – {m.donem_son} · {m.dosya_adi}</div></td>
            <td className="p-3 font-mono">{m.ozet.eslesen}/{m.ozet.ekstre_satir}</td>
            <td className="p-3 font-mono">{m.ozet.fazla_sayi}<div className="text-xs text-muted-foreground">{fmtMoney(m.ozet.fazla_toplam, m.para_birimi)}</div></td>
            <td className="p-3 font-mono">{m.ozet.eksik_sayi ?? <span className="text-xs text-muted-foreground">gösterilmiyor</span>}</td>
            <td className="p-3 text-xs">{m.olusturan_ad}<div className="text-muted-foreground">{new Date(m.created_at).toLocaleDateString("tr-TR")}</div></td>
          </tr>
        ))}</tbody>
      </table>
    )}
  </GlassCard>
);

export default function BankaMutabakat() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [hesaplar, setHesaplar] = useState([]);
  const [yeni, setYeni] = useState(false);
  const [m, setM] = useState(null);
  const load = useCallback(async () => {
    const [a, b] = await Promise.all([api.get("/mutabakatlar"), api.get("/hesaplar")]);
    setList(a.data); setHesaplar(b.data.filter((h) => h.tip === "banka"));
  }, []);
  useEffect(() => { load(); }, [load]);
  const ac = async (id) => { try { setM((await api.get(`/mutabakatlar/${id}`)).data); } catch (e) { toast.error(errMsg(e)); } };
  const yaz = can(user, "hesap:write");
  return (
    <div data-testid="mutabakat-page">
      <PageHeader eyebrow="Finans" title="Banka Mutabakatı" desc="Banka ekstresini (Excel, CSV veya PDF) yükleyin; hesap hareketleriyle tutar ve tarihe göre eşleştirilir, eksik ve fazla kalemler listelenir.">
        {m ? <button data-testid="mtb-geri" onClick={() => { setM(null); load(); }} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm border border-white/10 hover:bg-white/10"><ArrowLeft className="w-4 h-4" />Tüm mutabakatlar</button>
          : yaz && !yeni && <GradButton data-testid="mtb-yeni" onClick={() => setYeni(true)} disabled={hesaplar.length === 0}><Plus className="w-4 h-4" />Ekstre yükle</GradButton>}
      </PageHeader>
      {!m && yaz && hesaplar.length === 0 && <div className="text-sm text-amber-300 mb-4" data-testid="mtb-hesap-yok">Mutabakat için önce Banka & Kasa ekranından bir banka hesabı ekleyin.</div>}
      {yeni && !m && <MutabakatYukle hesaplar={hesaplar.filter((h) => h.aktif)} onCancel={() => setYeni(false)} onDone={(d) => { setYeni(false); setM(d); }} />}
      {m ? <MutabakatSonuc m={m} onChange={setM} /> : <Gecmis list={list} onAc={ac} />}
    </div>
  );
}
